import { createContext, useContext } from 'react';
import { CompanySize, Role } from '../rest/zapier';

export type PrefetchedData = {
  roles: Role[];
  companySizes: CompanySize[];
};

export const PrefetchedDataContext = createContext<PrefetchedData>({
  roles: [],
  companySizes: [],
});

export const usePrefetchedDataContext = () => useContext(PrefetchedDataContext);
